<div>
    <app-header [imagePath]="imagePath"></app-header>
    <div>
        <router-outlet></router-outlet>
    </div>

    <app-sidebar></app-sidebar>

</div>